export default "__VITE_ASSET__CDgL7f14__"